import React from 'react';
import {Trans} from '@lingui/react';

import Like from 'shared/ui/icons/Monitors/Like';

import PulseCircles from '../PulseCircles/PulseCircles';

import styles from './NoIssuesBlock.module.scss';

const NoIssuesBlock: React.FC = () => (
    <div className={styles.monitorItem}>
        <PulseCircles color={styles.colorGrey} animate={true} />
        <div className={styles.no_problems}>
            <Like />
            <Trans id="monitor.no.problem" message="Нет проблем" />
        </div>
    </div>
);

export default NoIssuesBlock;